import React from 'react';

interface ILabel {
  id: string;
  className?: string;
  children: React.ReactNode;
}

const Label: React.FC<ILabel> = ({ id, children, className }) => (
  <label className={`tw-lf-body-regular-md tw-block ${className}`} htmlFor={id}>
    {children}
  </label>
);

export default Label;
